import Vue from "vue";
import { computed } from "vue";

/**
 * Apply reactivity to route properties, based on the solution
 * described in https://medium.com/js-dojo/watch-vue-route-params-query-with-composition-api-97b3c8c402e
 */
export default router => () => {
  const routeData = Vue.observable({
    params: router.currentRoute.params,
    query: router.currentRoute.query
  });
  router.afterEach(route => {
    routeData.params = route.params;
    routeData.query = route.query;
  });

  const query = computed(() => routeData.query);
  const params = computed(() => routeData.params);

  return { query, params };
};
